import { render, staticRenderFns } from "./BenefitsIndex.vue?vue&type=template&id=d6b5e648"
import script from "./BenefitsIndex.vue?vue&type=script&lang=js"
export * from "./BenefitsIndex.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/styles/flexben.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports